import 'application.scss'
// Material Design Icons, bundled (was a retired CDN)
import '@mdi/font/css/materialdesignicons.css'
import * as url_utils from '../utils/url_utils';

require('@rails/ujs').start();
require('turbolinks').start();
require('@rails/activestorage').start();
require('channels');
require('jquery');
require('parsleyjs');

ParsleyConfig.autoBind = false;
var Cookies = require('js-cookie');
window.toastr = require('toastr');

toastr.options = {
  positionClass: 'toast-top-center',
  timeOut: '10000',
  closeButton: true,
};

// Screen readers often miss toasts, because toastr adds each one (and its
// aria-live) at the moment it appears. Repeat the text in live regions that
// are already on the page (WCAG 4.1.3). Errors and warnings interrupt.
function announce(message, urgent) {
  const id = urgent ? 'sr-announcer-assertive' : 'sr-announcer-polite';
  let region = document.getElementById(id);
  if (!region) {
    region = document.createElement('div');
    region.id = id;
    region.className = 'clip';
    region.setAttribute('aria-live', urgent ? 'assertive' : 'polite');
    region.setAttribute('role', urgent ? 'alert' : 'status');
    document.body.appendChild(region);
  }
  region.textContent = '';
  const text = String(message || '').replace(/<[^>]*>/g, '');
  setTimeout(() => { region.textContent = text; }, 100);
}
['success', 'info', 'warning', 'error'].forEach((type) => {
  const show = toastr[type];
  toastr[type] = (message, title, options) => {
    announce([title, message].filter(Boolean).join(': '), type === 'warning' || type === 'error');
    return show(message, title, options);
  };
});
document.addEventListener('DOMContentLoaded', () => { announce(''); announce('', true); });

import copy from 'copy-to-clipboard';
import tippy, { delegate } from 'tippy.js';

// StimulusReflex
import "controllers"

// Behaviour for the whole site. Event handlers are bound once, on document,
// so they keep working on pages Turbolinks visits and on content a
// StimulusReflex morph replaces. Anything that needs setting up per page
// (initial states) is in setUpPage(), run on each turbolinks:load.
// Components with their own state are Stimulus controllers (controllers/).

// -- Plans (subscriptions/new): highlight the chosen plan ----------------------
$(document).on('change', '.plan input[type=radio]', function () {
  $('.plan').removeClass('plan--active');
  $(this).closest('.plan').addClass('plan--active');
});

// -- Form validation (Parsley) ---------------------------------------------------
function bindParsleyForms() {
  $('[data-parsley-validate]').each(function () {
    new Parsley.Factory(this)
  });
}

// -- Cookie message ----------------------------------------------------------
// Google Analytics only loads once someone accepts analytics cookies. The
// message asks until they choose, and the cookies policy page lets them change
// their mind. It's fixed to the bottom of the screen: it sits above the audio
// player and pads the page by its height, so it never hides content or focus.
var ANALYTICS_ID = 'G-4NKBDZ2LDW';
var CONSENT_COOKIE = 'analyticsConsent'; // "granted" or "denied"

function setUpCookieConsent() {
  Cookies.remove('hideCookies'); // the old "seen the message" cookie
  var consent = Cookies.get(CONSENT_COOKIE);
  if (consent === 'granted') loadAnalytics();
  if (!consent) $('.cookiesMessage').removeClass('display-none');
  placeCookieMessage();
  showCookieChoice();
}

function loadAnalytics() {
  window['ga-disable-' + ANALYTICS_ID] = false; // in case they rejected, then accepted, on this page
  if (window.gtag) return;
  window.dataLayer = window.dataLayer || [];
  window.gtag = function () { window.dataLayer.push(arguments); };
  window.gtag('js', new Date());
  window.gtag('config', ANALYTICS_ID);
  var script = document.createElement('script');
  script.async = true;
  script.src = 'https://www.googletagmanager.com/gtag/js?id=' + ANALYTICS_ID;
  document.head.appendChild(script);
}

function chooseAnalytics(granted) {
  Cookies.set(CONSENT_COOKIE, granted ? 'granted' : 'denied', { expires: 365 });
  if (granted) {
    loadAnalytics();
  } else {
    // Stop this page sending anything more, and remove the _ga cookies,
    // which Google sets on the whole domain
    window['ga-disable-' + ANALYTICS_ID] = true;
    var domain = window.location.hostname.replace(/^www\./, '');
    Object.keys(Cookies.get()).forEach(function (name) {
      if (/^_ga/.test(name)) {
        Cookies.remove(name);
        Cookies.remove(name, { domain: domain });
      }
    });
  }
  showCookieChoice();
}

// The current choice, on the cookies policy page
function showCookieChoice() {
  var consent = Cookies.get(CONSENT_COOKIE);
  $('.cookieChoiceStatus').text(
    consent === 'granted' ? "You've accepted analytics cookies." :
    consent === 'denied' ? "You've rejected analytics cookies." :
    "You haven't chosen yet."
  );
}

function placeCookieMessage() {
  var $message = $('.cookiesMessage:visible');
  if (!$message.length) {
    document.body.style.paddingBottom = '';
    return;
  }
  var player = document.querySelector('.audio-player');
  $message.css('bottom', player ? player.offsetHeight : 0);
  document.body.style.paddingBottom = $message.outerHeight() + 'px';
}

$(window).on('resize', placeCookieMessage);

// The player is morphed in and out of its container by PlayerReflex
$(function () {
  var playerContainer = document.getElementById('audio-player-container');
  if (playerContainer) {
    new MutationObserver(placeCookieMessage).observe(playerContainer, { childList: true, subtree: true });
  }
});

$(document).on('click', '.cookiesChoice', function (event) {
  event.preventDefault();
  var fromMessage = $(this).closest('.cookiesMessage').length > 0;
  chooseAnalytics($(this).data('analytics') === 'granted');
  $('.cookiesMessage').addClass('display-none');
  placeCookieMessage();
  // The button has gone, so carry on from the main content (without scrolling)
  if (fromMessage) {
    var main = document.getElementById('main-content');
    if (main) main.focus({ preventScroll: true });
  }
});

// -- Accordions --------------------------------------------------------------
// .accordion__heading > button.accordion__title, followed by its
// .accordion__content. The button's aria-expanded says whether it's open, and
// closed content is hidden (from screen readers too). One open at a time.
// Closed on page load unless the button starts with aria-expanded="true".
function accordionContent(title) {
  return $(title).closest('.accordion__heading').next('.accordion__content');
}

var ACCORDION_DURATION = 200;

function canAnimate(element) {
  return element && element.animate && !window.matchMedia('(prefers-reduced-motion: reduce)').matches;
}

// animate: slide and fade the content open (clicks only, not page load).
// Closing is instant - animating it shifted the page under the pointer when
// opening one item closed another above it.
function setAccordion(title, open, animate) {
  var content = accordionContent(title);
  var el = content[0];
  $(title).attr('aria-expanded', open).toggleClass('accordion__title--expanded', open);

  if (el && el.getAnimations) el.getAnimations().forEach(function (animation) { animation.cancel(); });
  content.prop('hidden', !open).toggleClass('accordion__content--expanded', open);
  if (!open || !animate || !canAnimate(el)) return;

  var style = window.getComputedStyle(el);
  el.style.overflow = 'hidden';
  var animation = el.animate([
    { height: '0px', paddingTop: '0px', paddingBottom: '0px', opacity: 0 },
    { height: el.offsetHeight + 'px', paddingTop: style.paddingTop, paddingBottom: style.paddingBottom, opacity: 1 }
  ], { duration: ACCORDION_DURATION, easing: 'ease-out' });
  animation.onfinish = animation.oncancel = function () { el.style.overflow = ''; };
}

function setUpAccordions() {
  $('.accordion__title').each(function (i) {
    var content = accordionContent(this);
    var id = content.attr('id') || 'accordion-content-' + i;
    content.attr('id', id);
    $(this).attr('aria-controls', id);
    setAccordion(this, $(this).attr('aria-expanded') === 'true');
  });
  // Opens the item a link points to, e.g. /help#emails
  var hash = window.location.hash.replace('#', '');
  var target = hash && document.getElementById(hash);
  if (target && $(target).hasClass('accordion__title')) setAccordion(target, true);
}

$(document).on('click', '.accordion__title', function () {
  var title = this;
  var open = $(title).attr('aria-expanded') !== 'true';
  if (open) {
    $('.accordion__title[aria-expanded="true"]').not(title).each(function () { setAccordion(this, false); });
  }
  setAccordion(title, open, true);
});

// -- Link-buttons and copying ---------------------------------------------------
// Link-buttons (href="#" role="button", e.g. copy links, Select all) are
// keyboard focusable: like real buttons, activate them with Space as well as Enter
$(document).on('keydown', 'a[role="button"]', function (e) {
  if (e.key === ' ') {
    e.preventDefault();
    e.currentTarget.click();
  }
});

// Table rows with data-href (e.g. the Subscribers list) open it when clicked
// anywhere but their own links, buttons and fields
$(document).on('click', 'tr[data-href]', function (e) {
  if ($(e.target).closest('a, button, input, label, select, textarea').length) return;
  if (window.getSelection().toString()) return; // selecting text, not clicking
  var url = e.currentTarget.dataset.href;
  window.Turbolinks ? window.Turbolinks.visit(url) : (window.location.href = url);
});

$(document).on('click', '[data-copy-to-clipboard]', function (e) {
  e.preventDefault();
  var code = e.currentTarget.dataset.copyToClipboard;
  copy(code);
  var tooltip = tippy(e.currentTarget, {
    content: 'Copied ' + code,
    onHide(instance) {
      instance.setContent('');
    },
    placement: 'bottom'
  });
  tooltip.show();
});

// -- Tooltips ----------------------------------------------------------------
// Delegated from <html> (which Turbolinks keeps), so .tooltip elements on
// every page, and ones added by a morph, get tooltips. Each is created the
// first time its element is hovered or focused.
delegate(document.documentElement, {
  target: '.tooltip',
  placement: 'bottom'
});

// -- Mobile menu -------------------------------------------------------------
$(document).on('click', '.navicon', function (event) {
  event.preventDefault();
  var open = $(this).attr('aria-expanded') !== 'true';
  $(this).attr('aria-expanded', open);
  $(this).children('.mdi').toggleClass('mdi-menu', !open).toggleClass('mdi-close', open);
  $('.header-primary__nav').toggle(open);
});

// -- "Try again" link on the check-your-inbox page ------------------------------
// Remembers the page someone asked for a login link from (an access link or
// sign-up), so "try again" goes back there
$(document).on('click', 'form#new_access_key input:submit, form#regForm input:submit', function () {
  Cookies.set('tryAgainLink', window.location.href, { expires: 1 / 24 });
});

$(document).on('click', 'form#loginForm input:submit', function () {
  Cookies.remove('tryAgainLink');
});

function updateTryAgainLink() {
  var tryAgainLink = Cookies.get('tryAgainLink');
  if (tryAgainLink) {
    $('a.tryAgainLink').attr('href', tryAgainLink);
  }
}

// -- Profile URL from the artist name (while the name starts empty) ---------------
function slugify(string) {
  return string
    .toString()
    .trim()
    .toLowerCase()
    .replace(/\s+/g, '-')
    .replace(/[^\w\-]+/g, '')
    .replace(/\-\-+/g, '-')
    .replace(/^-+/, '')
    .replace(/-+$/, '');
}

function setUpSlugAutofill() {
  // Only for a new profile - never overwrite a URL someone already has
  $('#artist_display_name').attr('data-autofill-slug', $('#artist_display_name').val() ? null : 'true');
}

$(document).on('input', '#artist_display_name[data-autofill-slug]', function () {
  $('#artist_slug').val(slugify($(this).val()));
});

// -- Search (the magnifying glass above lists) -----------------------------------
function setSearchOpen(open) {
  $('#searchForm').toggle(open);
  $('#toggleSearch').toggleClass('active', open).attr('aria-expanded', open);
  $('#searchInput').val('');
  filterStuff();
  if (open) $('#searchInput').trigger('focus');
}

$(document).on('click', '#toggleSearch', function (event) {
  event.preventDefault();
  setSearchOpen($(this).attr('aria-expanded') !== 'true');
});

$(document).on('click', '#clearSearch', function (event) {
  event.preventDefault();
  setSearchOpen(false);
  $('#toggleSearch').trigger('focus');
});

var searchTimer;
$(document).on('input', '#searchInput', function () {
  clearTimeout(searchTimer);
  searchTimer = setTimeout(filterStuff, 150);
});

// Shows the rows/cards that contain the search text, then says how many match
function filterStuff() {
  var value = ($('#searchInput').val() || '').toLowerCase();
  var $items = $('.table tbody tr, .subscriber-list tbody tr, .card, .card-grid, .choice');
  var shown = 0;
  $items.each(function () {
    var match = $(this).text().toLowerCase().indexOf(value) > -1;
    $(this).toggle(match);
    if (match) shown++;
  });
  var none = $items.length > 0 && shown === 0;
  $('#noResults').toggle(none);
  $('.table thead, .subscriber-list thead').toggle(!none);
  if (value) announce(none ? 'No matches' : shown + (shown === 1 ? ' match' : ' matches'));
}

// -- Access link sign-up: a name is only needed if they don't share their email --
function toggleNameField() {
  var shareToggle = $('#access_key_share_email');
  if (!shareToggle.length) return;
  if (shareToggle.is(':checked')) {
    $('#access_key_name_input').slideUp(150);
    $('#access_key_name').removeAttr('required');
  } else {
    $('#access_key_name_input').removeClass('hidden').hide().slideDown(150);
    $('#access_key_name').attr('required', 'required');
  }
  if ($('#new_access_key').length) {
    new Parsley.Factory($('#new_access_key'));
  }
}

$(document).on('change', '#access_key_share_email', toggleNameField);

// -- Access link form: which tracks/folders ------------------------------------
// Recomputes one release checkbox's checked/indeterminate state from its tracks
function syncReleaseCheckboxState(releaseId) {
  var $tracks = $('#token_track_ids_input input[data-release-id="' + releaseId + '"]').not('.release-select-all');
  var $checkedTracks = $tracks.filter(':checked');
  var $releaseCheckbox = $('.release-select-all[data-release-id="' + releaseId + '"]');
  $releaseCheckbox.prop('checked', $tracks.length > 0 && $checkedTracks.length === $tracks.length);
  $releaseCheckbox.prop('indeterminate', $checkedTracks.length > 0 && $checkedTracks.length < $tracks.length);
}

function syncAllReleaseCheckboxStates() {
  $('#token_track_ids_input .release-select-all').each(function () {
    syncReleaseCheckboxState($(this).data('release-id'));
  });
}

// Bulk actions update every checkbox directly (not via individual 'change'
// triggers, which would fire the featured-options reflex once per checkbox)
// then fire exactly one 'change' on the tab so the reflex refreshes once
function setAllChoices(inputs, container, checked) {
  $(inputs).prop('checked', checked);
  syncAllReleaseCheckboxStates();
  $(container).trigger('change');
}

$(document).on('click', '#select_all_track_ids', function (event) {
  event.preventDefault();
  setAllChoices('#token_track_ids_input .choice input[type=checkbox]', '#tracksContent', true);
});
$(document).on('click', '#clear_all_track_ids', function (event) {
  event.preventDefault();
  setAllChoices('#token_track_ids_input .choice input[type=checkbox]', '#tracksContent', false);
});
$(document).on('click', '#select_all_categories', function (event) {
  event.preventDefault();
  setAllChoices('#token_categories_input .choice input', '#folderContent', true);
});
$(document).on('click', '#clear_all_categories', function (event) {
  event.preventDefault();
  setAllChoices('#token_categories_input .choice input', '#folderContent', false);
});

// Notify subscribers: select or clear all the new tracks
$(document).on('click', '#select_all_notification_tracks, #clear_all_notification_tracks', function (event) {
  event.preventDefault();
  $('.token-notification input[name="track_ids[]"]').prop('checked', this.id === 'select_all_notification_tracks');
});

// Notify subscribers: choose who gets the email, keeping the counts in step
function updateNotificationRecipientCount() {
  var $boxes = $('.token-notification input[name="recipient_ids[]"][type=checkbox]');
  if (!$boxes.length) return;
  var count = $boxes.filter(':checked').length;
  var subscribers = count + (count === 1 ? ' subscriber' : ' subscribers');
  $('.js-notification-recipient-count').text(subscribers);
  $('.js-notification-recipient-ticked').text(count);
  $('#send_notification').val('Email ' + subscribers).prop('disabled', count === 0);
}

$(document).on('click', '#select_all_notification_recipients, #clear_all_notification_recipients', function (event) {
  event.preventDefault();
  $('.token-notification input[name="recipient_ids[]"][type=checkbox]').prop('checked', this.id === 'select_all_notification_recipients');
  updateNotificationRecipientCount();
});
$(document).on('change', '.token-notification input[name="recipient_ids[]"]', updateNotificationRecipientCount);

// Checking/unchecking a release selects/deselects all of its tracks
$(document).on('change', '#token_track_ids_input .release-select-all', function () {
  var releaseId = $(this).data('release-id');
  $('#token_track_ids_input input[data-release-id="' + releaseId + '"]').not('.release-select-all').prop('checked', $(this).prop('checked'));
});

// Keep a release's checkbox in sync with its tracks
$(document).on('change', '#token_track_ids_input input[data-release-id]:not(.release-select-all)', function () {
  syncReleaseCheckboxState($(this).data('release-id'));
});

// -- Tabs (access control type: All music / By folder / By track) -------------------
function showTab(item) {
  $('.tabsContent:visible').attr('hidden', 'hidden');
  $('#' + $(item).attr('aria-controls')).removeAttr('hidden');
}

$(document).on('click', '.tabsItem', function () {
  showTab(this);
});

function showActiveTab() {
  $('.tabsItem').each(function () {
    if ($(this).children('input[type=radio]').is(':checked')) showTab(this);
  });
}

// -- Release zip downloads ------------------------------------------------------
// Dropbox zips the release before the download starts, which can take a
// while: the button spins and says so until the server's release_download
// cookie (set with this click's token) says the download has begun
var RELEASE_DOWNLOAD_GIVE_UP = 3 * 60 * 1000;

$(document).on('click', '.download-release-button', function (event) {
  event.preventDefault();
  var $button = $(this);
  if ($button.attr('aria-busy') === 'true') return;

  var token = Math.random().toString(36).slice(2);
  var url = new URL(this.href, window.location.href);
  url.searchParams.set('download_token', token);

  var $icon = $button.find('.mdi').first();
  var $label = $button.find('span').last();
  $button.data('download-release', { icon: $icon.attr('class'), label: $label.text() });
  $icon.attr('class', $icon.attr('class').replace(/mdi-download(-circle)?/, 'mdi-loading mdi-spin'));
  $label.text('Zipping release…');
  $button.attr('aria-busy', 'true');

  var started = Date.now();
  var timer = setInterval(function () {
    var begun = document.cookie.split('; ').indexOf('release_download=' + token) !== -1;
    if (begun || Date.now() - started > RELEASE_DOWNLOAD_GIVE_UP) {
      clearInterval(timer);
      document.cookie = 'release_download=; max-age=0; path=/';
      resetReleaseDownloadButton($button);
    }
  }, 500);

  window.location.href = url.toString();
});

function resetReleaseDownloadButton($button) {
  var saved = $button.data('download-release');
  if (!saved) return;
  $button.find('.mdi').first().attr('class', saved.icon);
  $button.find('span').last().text(saved.label);
  $button.removeAttr('aria-busy').removeData('download-release');
}

// Don't keep a spinning button in Turbolinks' cache of the page
$(document).on('turbolinks:before-cache', function () {
  $('.download-release-button[aria-busy=true]').each(function () { resetReleaseDownloadButton($(this)); });
});

// -- Sortable tables (stats table view) -----------------------------------------
// Each sortable column's header is a button; aria-sort on the th says which
// column is sorted, and which way
$(document).on('click', '.table--sorted th:not(.not-sorted) .table__sort', function () {
  var th = $(this).closest('th');
  var table = th.closest('table');
  var rows = table.find('tbody tr').toArray().sort(comparer(th.index()));
  // A column that starts sorted descending (e.g. stats downloads) flips to ascending first
  var ascending = th.attr('aria-sort') === 'descending' ? true : th.attr('aria-sort') === 'ascending' ? false : !th.hasClass('descending');
  table.find('th').removeClass('sorted descending').removeAttr('aria-sort');
  th.addClass('sorted').toggleClass('descending', !ascending).attr('aria-sort', ascending ? 'ascending' : 'descending');
  if (!ascending) rows = rows.reverse();
  table.find('tbody').append(rows);
});

function comparer(index) {
  return function (a, b) {
    var valA = getCellValue(a, index), valB = getCellValue(b, index);
    return isNumber(valA) && isNumber(valB) ? valA - valB : valA.localeCompare(valB);
  };
}

function getCellValue(row, index) {
  var cell = $(row).children('td').eq(index);
  var value = cell.attr('data-sort');
  return value === undefined ? cell.text().trim() : value;
}

function isNumber(n) {
  return !isNaN(parseFloat(n)) && isFinite(n);
}

// -- Profile preview: choosing another access link drops the old one from the URL --
$(document).on('change', '#preview_select', function () {
  url_utils.updateCurrentUrl(url_utils.removeQueryParameter(window.location.href, "token_id"));
});

// Links that open a new tab say so to screen readers (sighted users mostly get
// an open-in-new icon), and can't reach back into this page (rel=noopener).
// Runs on load and whenever links are added, e.g. by a reflex morph.
function markNewTabLinks(root) {
  $(root).find('a[target="_blank"]').addBack('a[target="_blank"]').each(function () {
    if (this.hasAttribute('data-new-tab')) return;
    this.setAttribute('data-new-tab', '');
    var rel = (this.getAttribute('rel') || '').split(' ');
    if (rel.indexOf('noopener') === -1) this.setAttribute('rel', rel.concat('noopener').join(' ').trim());
    if (/new tab/i.test(this.textContent)) return;
    var label = this.getAttribute('aria-label');
    if (label) {
      this.setAttribute('aria-label', label + ' (opens in new tab)');
    } else {
      $(this).append('<span class="clip"> (opens in new tab)</span>');
    }
  });
}

var newTabObserver;
function newTabLinks() {
  markNewTabLinks(document.body);
  if (newTabObserver || !window.MutationObserver) return;
  newTabObserver = new MutationObserver(function (mutations) {
    mutations.forEach(function (m) {
      m.addedNodes.forEach(function (node) {
        if (node.nodeType === 1) markNewTabLinks(node);
      });
    });
  });
  newTabObserver.observe(document.documentElement, { childList: true, subtree: true });
}

// Flash messages from the server (application/_flash.haml), as toasts
function showFlashMessages() {
  document.querySelectorAll('.flash-message').forEach(function (el) {
    var type = toastr[el.dataset.type] ? el.dataset.type : 'info';
    toastr[type](el.dataset.message);
    el.remove();
  });
}

// Set up each page (Turbolinks runs this on every visit, and the first load)
function setUpPage() {
  showFlashMessages();
  newTabLinks();
  setUpCookieConsent();
  updateTryAgainLink();
  setUpSlugAutofill();
  setUpAccordions();
  bindParsleyForms();
  toggleNameField();
  syncAllReleaseCheckboxStates();
  showActiveTab();
  updateNotificationRecipientCount();
}

$(document).on('turbolinks:load', setUpPage);
